import * as React from "react";
import { CorrectionItemPreviewProps, CorrectionItemPreview } from "../WizardTypings";
import { CorrectionBreakdownItem } from "../../CorrectionBreakdownItem";
import { Correction } from "../../../Request/DcfRequestReducer";
import LoadingWithMessage from "../../../../misc/components/LoadingWithMessage";
import { SubjectType } from "webportalclient";
import { useWebPortalApiClient } from "../../../../misc/api/WebPortalTokenClient";
import { useCurrentStudyConfigurationContext } from "../../../../Core/CurrentStudyConfigurationContext";

const PreviewSelector = (corrections: Correction[]): boolean => corrections.length > 0 && corrections[0].entity == "Subject" && corrections[0].field == "Type";

const SubjectTypePreviewItem = ({ corrections }: CorrectionItemPreviewProps): JSX.Element => {
    
    const client = useWebPortalApiClient();
    const [loadingSubjectTypes, setLoadingSubjectTypes] = React.useState<boolean>(true);
    const [subjectTypes, setSubjectTypes] = React.useState<SubjectType[]>(null);
    const { fieldDisplayText } = useCurrentStudyConfigurationContext();

    const getTypeName = (typeCode: string): string => {
        const type = subjectTypes.find(st => st.id == typeCode);
        //Falling back to the type code if the type no longer exists.
        return type ? type.name : typeCode;
    };

    const subjectTypeDisplayText = fieldDisplayText.SubjectType;

    React.useEffect(() => {

        setLoadingSubjectTypes(true);

        client.client.getSubjectTypes()
            .then((st) => {
                setSubjectTypes(st.value);

                setLoadingSubjectTypes(false);
            });

    }, [client.client]);

    if (!(PreviewSelector(corrections))) {
        return null;
    }

    return loadingSubjectTypes ?
        <LoadingWithMessage message={`Loading ${subjectTypeDisplayText}s`} />
        : <CorrectionBreakdownItem key={`BreakdownItem${name}`} fieldName={corrections[0].field} from={getTypeName(corrections[0].oldValue)} to={getTypeName(corrections[0].newValue)} />;
};

const SubjectTypePreview: CorrectionItemPreview = {
    previewElement: SubjectTypePreviewItem,
    previewSelector: PreviewSelector
};

export default SubjectTypePreview;
